module.exports = __webpack_public_path__ + "media/Hot Tips.488cfcfd.mp3";